import React, {PropTypes} from "react";
import axios from "axios";
import Constants from "../../classes/constants";

class ProfilePhoto extends React.Component {

  constructor() {
    super();
    this.state = {error: false, old: false, profilePic : Constants.defaultProfilePicture[0]}
  }

  componentWillReceiveProps(nextProps) {
      this.setState({error: false, old: false});
      let emp = nextProps.empno;
      if(emp){
        axios.get(process.env.REQ_URL + "/assets/picture/" + emp+ "?" + new Date().getTime().toString(), {
           withCredentials: true,
           headers: {'X-Requested-With': 'XMLHttpRequest'}
        }).then((response)=> {
           if(response.data.data != null || response.data.data !=''){
              this.setState({profilePic: response.data.data});
           }else{
              this.setState({profilePic: Constants.defaultProfilePicture[0]});
           }
        }).catch((error) => {
            this.setState({profilePic: Constants.defaultProfilePicture[0]});
        });

      }
  }

  componentDidMount() {
        if(this.props.empno){
            axios.get(process.env.REQ_URL + "/assets/picture/" + this.props.empno + "?" + new Date().getTime().toString(), {
                withCredentials: true,
                headers: {'X-Requested-With': 'XMLHttpRequest'}
            }).then((response)=> {
                   if(response.data.data != null || response.data.data !=''){
                      this.setState({profilePic: response.data.data});
                   }else{
                       this.setState({profilePic: Constants.defaultProfilePicture[0]});
                   }
            }).catch((error) => {
                this.setState({profilePic: Constants.defaultProfilePicture[0]});
            });
        }
  }

  render() {
    return (
      <img src={this.state.profilePic} height={this.props.height} width={this.props.width}/>
    );
  }

}

ProfilePhoto.propTypes = {};

export default ProfilePhoto;





/** WEBPACK FOOTER **
 ** ./src/components/common/ProfilePhoto.js
 **/